<template>
  <div class="camera--wrapper">
    <js-camera
      ref="js-camera"
      audio="false"
      facing="back"
    ></js-camera>
  </div>
</template>

<script>
import 'js-camera';
import Logger from '@/lib/logger';

export default {
  name: 'v2-camera',
  data: () => ({
    videoStream: null,
    camera: null,
  }),
  methods: {
    isDeniedError(error) {
      if (!error) return false;
      if (/NotAllowedError/ig.test(error.name)) return true;
      if (/denied/ig.test(error.message)) return true;
      return false;
    },
    emitPermissionError(e, isDenied = true) {
      const error = e || new Error('Permission denied');
      error.isDeniedError = isDenied;
      this.$emit('onError', error);
    },
    registerCameraEvents() {
      this.camera.on('opened', () => {
        this.$emit('onStart');
      });
    },
    async openCamera() {
      if (!this.camera) this.$emit('onError', new Error('Camera not settled up'));
      const permStatus = await this.camera.permission();
      if (permStatus === 'denied') {
        this.emitPermissionError();
        return;
      }
      try {
        this.$emit('onStarting');
        await this.camera.open('back');
        return;
      } catch (error) {
        const isDeniedError = this.isDeniedError(error);
        if (!isDeniedError) Logger.error(error);
        this.emitPermissionError(error, isDeniedError);
      }
    },
    takePicture() {
      if (!this.camera || !this.camera.opened) return null;
      const base64 = this.camera.capture({ format: 'image/jpeg' });
      return base64;
    },
    closeCamera() {
      this.camera.close();
    },
  },
  mounted() {
    this.camera = this.$refs['js-camera'];
    this.registerCameraEvents();
  },
};
</script>

<style lang="scss" scoped>
  .camera--wrapper {
    height: 100%;
  }

  .camera {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .canvas {
    display: none;
  }
</style>
